import { ReactNode } from "react";
import { Box, Skeleton, Typography, Button, Stack } from "@mui/material";
import { Refresh } from "@mui/icons-material";

interface ComponentLoaderProps {
    loading: boolean;
    error: string | null;
    onRetry?: () => void;
    skeletonHeight?: number;
    children: ReactNode;
}

export default function ComponentLoader({
                                            loading,
                                            error,
                                            onRetry,
                                            skeletonHeight = 120,
                                            children,
                                        }: ComponentLoaderProps) {
    if (loading) {
        return (
            <Skeleton
                variant="rounded"
                width="100%"
                height={skeletonHeight}
                sx={{ borderRadius: 3 }}
            />
        );
    }

    if (error) {
        return (
            <Box
                sx={{
                    height: skeletonHeight,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "1px dashed",
                    borderColor: "error.light",
                    borderRadius: 3,
                    bgcolor: "error.main",
                    opacity: 0.08,
                }}
            >
                <Stack alignItems="center" spacing={1}>
                    <Typography variant="caption" color="error.main">
                        {error}
                    </Typography>
                    {onRetry && (
                        <Button
                            size="small"
                            startIcon={<Refresh />}
                            onClick={onRetry}
                            color="error"
                        >
                            Riprova
                        </Button>
                    )}
                </Stack>
            </Box>
        );
    }

    return <>{children}</>;
}